/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefs_TitleInputs */

const cs_settings_prefs_title = /** @type {(inputs: Settings_Prefs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předvolby`)
};

const en_settings_prefs_title = /** @type {(inputs: Settings_Prefs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferences`)
};

/**
* | output |
* | --- |
* | "Preferences" |
*
* @param {Settings_Prefs_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_prefs_title = /** @type {((inputs?: Settings_Prefs_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefs_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefs_title(inputs)
	return cs_settings_prefs_title(inputs)
});